import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import {
  GetStationeryRequest,
  StationeryOptions
} from "./interfaces/get-stationery";
import { Environment } from "@coxauto-ui/cxm/communications/interfaces";

export async function getStationery(
  data: GetStationeryRequest,
  env: Environment
): Promise<StationeryOptions> {
  const url = `${getBaseUrl(env)}cxm/stationery`;
  const header = await getHeader();
  const response = await fetchWrapper.getAsync<StationeryOptions>(
    `${url}?vinDealerId=${data.dealerId}`,
    header
  );

  if (response && response.data && !response.hasError) {
    return response.data;
  } else {
    console.warn(
      `Error fetching stationery for dealerId: ${data.dealerId}`,
      response?.error
    );
    return { stationeries: [] }; // Return empty response on error
  }
}
